import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { get } from 'lodash';

// TODO

import isValidElement from './isValidElement';
// Only use the data index that is passed to the TableColumn as dataIndex
function filterObject(obj, children) {
  const dataKeys = [];
  React.Children.forEach(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      var _child$props$tableCel;
      dataKeys.push({
        key: child.props.dataIndex,
        render: child.props.render,
        isCheckbox: !!child.props.isCheckbox,
        tableCellProps: _extends({}, (_child$props$tableCel = child.props.tableCellProps) != null ? _child$props$tableCel : {}, {
          onClick: e => {
            var _child$props, _child$props$tableCel2, _child$props$tableCel3;
            child == null ? void 0 : (_child$props = child.props) == null ? void 0 : (_child$props$tableCel2 = _child$props.tableCellProps) == null ? void 0 : (_child$props$tableCel3 = _child$props$tableCel2.onClick) == null ? void 0 : _child$props$tableCel3.call(_child$props$tableCel2, e, obj);
          }
        }),
        isMenu: !!child.props.isMenu
      });
    }
  });
  const rowsWithProps = dataKeys.map(item => {
    const value = get(obj, item.key);
    const element = item.render ? item.render(value, obj) : value;
    const hasCustomRender = !!item.render;
    let itemToRender = isValidElement(element) ? element : '__ERROR';
    if (itemToRender === '__ERROR') {
      itemToRender = null;
    }
    return {
      [item.key]: {
        itemToRender,
        isCheckbox: item.isCheckbox,
        tableCellProps: item.tableCellProps,
        hasCustomRender,
        isMenu: item.isMenu
      },
      tableKey: obj._id
    };
  });
  const newObject = Object.assign({}, ...rowsWithProps);
  return newObject;
}
export { filterObject };
export { default as removePropFromComponent } from './removePropFromComponent';